export default "__VITE_ASSET__DqTSOV_x__"